import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getSocietyBanksReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.is_active !== undefined) params.is_active = searchQuery.is_active;

    return axiosInstance.get(apiEndpoints.GET_SOCIETY_BANKS_API, { params });
}

export const getSocietyBankDetailsReq = (action) => {
    const id = action?.data?.id || '';
    const society_id = action?.data?.society_id || '';
    const url = apiEndpoints.GET_SOCIETY_BANK_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url, { params: { society_id } });
}

export const createSocietyBankReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_SOCIETY_BANK_API, payload);
}

export const updateSocietyBankReq = (action) => {
    const id = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_SOCIETY_BANK_API.replace(':id', id);
    return axiosInstance.put(url, payload);
}

export const deleteSocietyBankReq = (action) => {
    const id = action?.data?.id || '';
    const society_id = action?.data?.society_id || '';
    const url = apiEndpoints.DELETE_SOCIETY_BANK_API.replace(':id', id);
    return axiosInstance.delete(url, { params: { society_id } });
}

export const getBankJournalEntriesReq = (action) => {
    const id = action?.data?.id || '';
    const searchQuery = action?.data || {};
    const url = apiEndpoints.GET_BANK_JOURNAL_ENTRIES_API.replace(':id', id);
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 20,
    };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;

    return axiosInstance.get(url, { params });
}

export const getSocietyBanksDropdownReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {};
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.account_type) params.account_type = searchQuery.account_type;
    return axiosInstance.get(apiEndpoints.GET_SOCIETY_BANKS_DROPDOWN_API, { params });
}
